export enum InventoryOwnerType {
    vendor = "vendor",
    juniper = "juniper",
}